import {Apollo, gql} from 'apollo-angular';
import { Component, OnInit, Output, ViewChild, EventEmitter, Injector } from '@angular/core';
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {EventService} from "../../../services/event.service";
import {ToastrService} from "ngx-toastr";
import {HttpClient} from "@angular/common/http";
import {ProgressService} from "../../../services/progress.service";
import {Router} from "@angular/router";

import {AuthenticationService} from "../../../../authentication/authentication.service";

import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {FacebookconfirmationDialogComponent} from "../facebook-confirmation-dialog/facebook-confirmation-dialog.component";
import {FacebookFundraiserService} from '../../../services/facebook-fundraiser.service';
import { BaseDialogComponent } from '../base-dialog/base-dialog.component';
import {FacebookService} from "../../../services/facebook.service";
import {FacebookLoginResponse} from "@capacitor-community/facebook-login";

@Component({
    selector: 'facebook-fundraiser-dialog',
    templateUrl: './facebook-fundraiser-dialog.component.html'
})
export class FacebookFundraiserDialogComponent extends BaseDialogComponent implements OnInit {
    public title: string;
    public story: string;
    public canCallCreateFundraiserAction: boolean;
    private externalFundraiserId: number;
    private externalFundraiserUri: string;
    private goalAmountInCents: number;
    private externalEventName: string;
    private externalEventUri: string;
    private eventStartDate: any;
    private closeDonationsDateInSeconds: any;
    private participantEventUrl : string;
    private llsAccountLogin : string;
    private facebookAccountLogin : string;

    state: any = {
        isSubmitted: false
    };
    @Output() onInit = new EventEmitter();
    @ViewChild('f', { static: true }) form;

    constructor(
        public activeModal: NgbActiveModal,
        public eventService: EventService,
        private ToastrService: ToastrService,
        private http: HttpClient,
        private progressService: ProgressService,
        private router: Router,
        private apollo: Apollo,
        private authService: AuthenticationService,
        private facebookFundraiserService: FacebookFundraiserService,
        public modalService: NgbModal,
        injector: Injector,
        private facebookService: FacebookService,
    ) {
        super(injector);
    }

    ngOnInit() {
        this.onInit.emit(this.form);
        this.canCallCreateFundraiserAction = true;
        var selectedEvent = this.eventService.selectedEvent;
        var participant = selectedEvent.gql.Participant[0];
        if(participant) {
            var posts = participant.fundraiser.fundraiserPosts;
            var eventUrls = participant.participantEventUrls;
            if(eventUrls.length > 0) {
                this.participantEventUrl = eventUrls[0].participantEventUrl;
            }
            if(posts.length > 0) {
                this.title = posts[0].title;
                this.story = this.stripText(posts[0].htmlContent);
            }
            this.externalFundraiserId = participant.fundraiser.fundraiserId;
            this.externalFundraiserUri = participant.fundraiser.fullUrl;
            this.goalAmountInCents = selectedEvent.donations.individual.goal * 100;
            this.closeDonationsDateInSeconds = participant.fundraiser.closeDonationsDate / 1000;
            this.externalEventName = selectedEvent.label;
            this.externalEventUri = this.participantEventUrl;
            this.eventStartDate = selectedEvent.dateEvent;
        }
    }

    async createFacebookFundraiser() {
        this.state.isSubmitted = true;
        if (!this.form.valid) return;
        this.canCallCreateFundraiserAction = false;
        this.progressService.startProgress(false);

        const result: FacebookLoginResponse = await this.facebookService.getAccessToken();
        this.facebookFundraiser(result.accessToken.token, result.accessToken.userId);
    }

    private buildFacebookFundraiserPayload(providerUID) {
        return {
            "name": this.title,
            "description": this.story,
            "goalAmountInCents": this.goalAmountInCents,
            "endTimestamp": this.closeDonationsDateInSeconds,
            "externalId": this.externalFundraiserId,
            "externalFundraiserUri": this.externalFundraiserUri,
            "externalEventName": this.externalEventName,
            "externalEventUri": this.externalEventUri,
            "externalEventStartTime": this.eventStartDate,
            "facebookUserEmail": this.facebookAccountLogin,
            "llsAccountUsername": this.llsAccountLogin,
            "facebookUserId": providerUID
        };
    }

    private facebookFundraiser(accessToken, providerUID) {
        var payload = this.buildFacebookFundraiserPayload(providerUID);
        const obs = this.facebookFundraiserService.createFacebookFundraiser(accessToken, payload);

        if(!!obs) {
            obs.subscribe((res: any) => {
                if(res['status'] !== 'CREATED') {
                    if(res['status'] === 'DUPLICATE_FUNDRAISER_NAME') {
                        this.ToastrService.error('You already created a Facebook fundraiser using this title.');
                    } else {
                        this.ToastrService.error(res['message']);
                    }
                    this.state.isSubmitted = false;
                    this.canCallCreateFundraiserAction = true;
                    this.progressService.stopProgress(false);
                } else {
                    //check link status

                    if(res['linkStatus'] === 'ERROR') {
                        this.ToastrService.error('There was a problem linking the Facebook Fundraiser.');
                    } else {
                        const messages = ['Facebook Fundraiser linked Successfully.'];
                        this.reloadFacebookFundraiserProfile();
                        const confirmationModal = this.modalService.open(FacebookconfirmationDialogComponent, {backdrop  : 'static'});
                        confirmationModal.componentInstance.messages = messages;
                    }
                    this.progressService.stopProgress(false);
                    this.closeModal();
                }
            }, err => {
                this.ToastrService.error('A problem occurred while creating or linking the Facebook fundraiser');
                this.state.isSubmitted = false;
                this.canCallCreateFundraiserAction = true;
                this.progressService.stopProgress(false);
            });
        }
    }

    closeModal() {
        this.activeModal.close();
    }

    private stripText(value) {
        // Surround the value in <p> tags in case we are passed a literal string (non-HTML) value.
        // This avoids a syntax error in the jQuery().text() call.
        return  value ? jQuery('<p>' + value + '</p>').text() : '';
    };

    // Reloads the facebook fundraiser profile section from GraphQL
    reloadFacebookFundraiserProfile() {
        this.progressService.startProgress(false);

        let participantId = this.eventService.selectedEvent.participantId;
        var partialQuery = `Participant(participantId: ${participantId}) {
                    participantId
                    individualConstituent {
                      individualConstituentId
                    }
                    event {
                      eventId
                    }
                    fundraiser {
                      activeFacebookFundraiserProfiles {
                        facebookFundraiserId
                      }
                    }
                  }`;
        var query = gql`
                  query EventRelatedQuery {
                    ${partialQuery}
                  }`;

        this.apollo.query<any>({
            fetchPolicy: "network-only",
            query: query
        }).subscribe(res => {
            this.eventService.selectedEvent.gql.Participant[0].fundraiser.activeFacebookFundraiserProfiles = res.data.Participant[0].fundraiser.activeFacebookFundraiserProfiles;
            this.progressService.stopProgress(false);
            if (this.router.url.includes('/facebook/fundraiser')) {
                if (this.eventService.selectedEvent.gql.Participant[0].fundraiser.activeFacebookFundraiserProfiles.length > 0) {
                    this.router.navigate(['/facebook/fundraiser', this.eventService.selectedEvent.gql.Participant[0].fundraiser.activeFacebookFundraiserProfiles[0].facebookFundraiserId]);
                }
            }
            this.canCallCreateFundraiserAction = true;
            this.state.isSubmitted = false;
        });
    }

}
